import script from "./StableTokenPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./StableTokenPill.vue?vue&type=script&setup=true&lang=ts"

import "./StableTokenPill.vue?vue&type=style&index=0&id=19c8c801&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c8c801"]])

export default __exports__